function formatPersonName(first?: string | null, last?: string | null): string {
	return `${first ?? ''} ${last ?? ''}`.trim();
}

export function getSessionPatientDisplayName(
	session: Sessions.Session,
): string {
	const participants = session.participants ?? [];

	if (session.type === 'GROUP') {
		const first = participants[0]?.user;
		const name = formatPersonName(first?.first_name, first?.last_name);
		if (name && participants.length > 1) {
			return `${name} +${participants.length - 1}`;
		}
		if (name) return name;
		return participants.length > 0
			? `Grupo (${participants.length})`
			: 'Sessão em grupo';
	}

	if (session.type === 'P2P') {
		const patientParticipant = participants.find(
			(participant) =>
				participant.entity_type === 'PATIENT' ||
				participant.patient_id != null,
		);
		const patientName = patientParticipant?.patient?.full_name?.trim();
		if (patientName) return patientName;
	}

	const user = session.user ?? participants[0]?.user;
	const name = user
		? formatPersonName(user.first_name, user.last_name)
		: formatPersonName(session.first_name, session.last_name);

	return name || 'Paciente';
}
